<template>
	<vs-popup
		:title="$t('payRewardToAuthor')"
		class="set-ticket-done"
		:active.sync="activeProp"
	>
		{{ $t('allowAuthorPaymentReward') }}
		<vs-input
			:label="$t('authorsReward')"
			class="mt-4"
			v-model="newPriceInput"
			v-validate="'required'"
		/>
		<div class="set-ticket-done__controls">
			<vs-button
				@click="setAmountAuthor"
				color="success"
			>{{ $t('pay') }}</vs-button>

			<vs-button
				@click="close"
				color="#9a9a9a"
				type="flat"
			>{{ $t('doCancel') }}</vs-button>
		</div>
	</vs-popup>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";

export default {
	name: "SetStageDonePopup",
	mixins: [databaseManager, notifier],
	props: {
		active: { default: false, type: Boolean },
		selectedStage:  { default: [] },
	},
    data() {
		return {
            newPriceInput: null,
		}
	},
	computed: {
		activeProp: {
			get() {
				this.newPriceInput = this.selectedStage.estimatedAmountAuthor;
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				return this.active;
			}
		}
	},
	methods: {
		// confirm() {
		// 	this.$emit("confirm");
		// 	this.activeProp = false;
		// },
		close() {
			this.activeProp = false;
		},
		async setAmountAuthor() {
			this.activeProp = true;

			try {
				let newPrice = null;

                newPrice = await this.dbSetPriceAuthorAmount(this.selectedStage.id, this.newPriceInput);
                // this.orderMilestone.price_junior_middle = this.newPriceInput;
				this.newPriceInput = null;

				this.activeProp = false;

				this.notifySuccess(this.$t('paymentIsFixed'));

				this.$emit("confirm");

                // this.$emit('changeStage', {
                //         stage: this.orderMilestone
                //     });

			} catch (e) {
				this.notifyError(e.message)
			}
		},
	},
    mounted() {
        this.newPriceInput = this.selectedStage.estimatedAmountAuthor;
		console.log(this.newPriceInput);
    }
}
</script>

<style lang="scss">
@import "./src/assets/scss/vuexy/variables";

.set-ticket-done {
	&__controls {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.vs-popup {
		max-width: 450px !important;
		width: 100% !important;
		padding: 0;

		&--content {
			width: 100%;
			height: 100%;
		}

		&--close,
		&--title h3 {
			color: $success;
		}

		&--button {
			display: flex;
			justify-content: flex-end;
			padding-top: 15px;
		}
	}

	.vs-input {
		width: 100%;
	}

	.vs-input--label {
		transition: color 0.3s ease;
	}

	.vs-input-primary.isFocus .vs-input--label {
		color: $success;
	}

	.vs-input-primary .vs-input--input:focus {
		border-color: $success !important;
	}
}
</style>
